import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-menu-adminlog",
  "use": "icon-menu-adminlog-usage",
  "viewBox": "0 0 16 15",
  "content": "<symbol viewBox=\"0 0 16 15\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-menu-adminlog\">\n<path d=\"M11.7 6.25C12.155 6.25 12.584 6.325 13 6.425V2.725L6.5 0L0 2.725V6.8125C0 10.6 2.769 14.1375 6.5 15C6.955 14.9 8.5 14.7101 8.5 14.5C7.681 13.6125 6.916 12.5476 6.916 11.2726C6.916 8.51006 8.827 6.25 11.7 6.25Z\" fill=\"#314455\" />\n<path d=\"M12 7C9.78667 7 8 8.78667 8 11C8 13.2133 9.78667 15 12 15C14.2133 15 16 13.2133 16 11C16 8.78667 14.2133 7 12 7ZM12 8.37333C12.6267 8.37333 13.12 8.88 13.12 9.49333C13.12 10.1067 12.6133 10.6133 12 10.6133C11.3867 10.6133 10.88 10.1067 10.88 9.49333C10.88 8.88 11.3733 8.37333 12 8.37333ZM12 13.7467C11.0667 13.7467 10.2533 13.28 9.76 12.5867C9.81333 11.8667 11.2667 11.5067 12 11.5067C12.7333 11.5067 14.1867 11.8667 14.24 12.5867C13.7467 13.2933 12.9333 13.7467 12 13.7467Z\" fill=\"#919BA8\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/svgIcon/svg/menu-adminlog.svg
// module id = 1g56
// module chunks = 258